import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
//import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const [showOtrosServicios, setShowOtrosServicios] = useState(false);
  const [showInstituciones, setShowInstituciones] = useState(false);

  const toggleOtrosServicios = () => {
    setShowOtrosServicios(!showOtrosServicios);
  };
  const toggleInstituciones = () => {
    setShowInstituciones(!showInstituciones);
  };

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img src={`${process.env.REACT_APP_CLOUDFRONT_IMAGES}/nuevos-logotipos/logo-coneecta-horzontal.png`} alt="Logo Coneecta" style={{ width: "10rem" }} />
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ padding: "10px 15px" }} to="https://coneecta.net/" offset={-60}>
            Inicio
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ padding: "10px 15px" }} to="https://coneecta.net/buscador-de-empleo" offset={-60}>
            Buscador de empleo
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ padding: "10px 15px" }} to="https://coneecta.net/empresa" offset={-60}>
            Empresa
          </Link>
        </li>
        {/*
        <li className="semiBold font15 pointer" onClick={toggleInstituciones}>
          <Link className="whiteColor" style={{ padding: "10px 15px", cursor: "pointer" }} offset={-60}>
            Instituciones
          </Link>
        </li>
        {showInstituciones && (
          <>
            <li className="semiBold font15 pointer" onClick={toggleInstituciones}>
              <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ cursor: "pointer" }} to="/directivos/login"> Directivos</Link>
            </li>
            <li className="semiBold font15 pointer" onClick={toggleInstituciones}>
              <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ cursor: "pointer" }} to="/vinculadores/login"> Vinculadores</Link>
            </li>
          </>
        )}
        */}
        <li className="semiBold font15 pointer" onClick={toggleOtrosServicios}>
          <Link className="whiteColor" style={{ padding: "10px 15px", cursor: "pointer" }} offset={-60}>
            Cerca de ti
          </Link>
        </li>
        {showOtrosServicios && (
          <>
            <li className="semiBold font15 pointer" onClick={toggleOtrosServicios}>
              <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ cursor: "pointer" }} to="https://coneecta.net/cerca-de-ti/empleo"> Empleo</Link>
            </li>
            <li className="semiBold font15 pointer" onClick={toggleOtrosServicios}>
              <Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ cursor: "pointer" }} to="https://coneecta.net/cerca-de-ti/educación"> Educación</Link>
            </li>
            <li className="semiBold font15 pointer" onClick={toggleOtrosServicios}>
              {/*<Link onClick={() => toggleSidebar(!sidebarOpen)} className="whiteColor" style={{ cursor: "pointer" }} to="https://coneecta.net/cerca-de-ti/coneecta-en-números"> Coneecta en números</Link>*/}
            </li>
          </>
        )}
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
